<div class="addContainer">

  <!-- Header -->
  <div class="chat-header">
    <div class="chat-header-info">
      <div class="chat-avatar">
        <i class="fa fa-comments"></i>
      </div>
      <div>
        <div class="chat-title">{{ dialogTitle }}</div>
        <div class="chat-subtitle">
          <span *ngIf="messages.length > 0">{{ messages.length }} message{{ messages.length > 1 ? 's' : '' }}</span>
          <span *ngIf="messages.length === 0">Aucun message</span>
          &nbsp;
          <span class="refresh-btn" (click)="getItemsMessages()" title="Actualiser">
            <i class="fa fa-redo fa-xs"></i>
          </span>
        </div>
      </div>
    </div>
    <button mat-icon-button mat-dialog-close class="modal-close-button" aria-label="Fermer" type="button"
      (click)="clearInterv()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <div class="chat-container">

      <!-- Empty state -->
      <div class="empty-state" *ngIf="messages.length === 0">
        <mat-icon class="empty-icon">forum</mat-icon>
        <p class="empty-title">Aucun message</p>
        <p class="empty-sub">Démarrez la conversation ci-dessous</p>
      </div>

      <!-- Messages -->
      <div class="messages-container">
        <div *ngFor="let msg of messages" class="message-row" [class.sent]="msg.isSent">
          <div class="message-bubble">
            <div class="message-header">
              <span class="sender">{{ msg.isSent ? 'Vous' : msg.created_by_login }}</span>
              <span class="timestamp">{{ msg.created_at | dateTimeFormat }}</span>
            </div>
            <div class="message-content">
              <span *ngIf="msg.text">{{ msg.text }}</span>
              <div *ngIf="msg.image_url" class="attachment">
                <mat-icon class="attachment-icon">attach_file</mat-icon>
                <a [href]="msg.image_url" target="_blank" class="file-link">
                  <i class="fa fa-download mr-1"></i> Télécharger le fichier
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Composer -->
      <form class="composer" (ngSubmit)="onSendMessage()" #frm="ngForm">
        <button type="button" mat-icon-button class="attach-btn" matTooltip="Joindre un fichier"
          (click)="fileInput.click()">
          <mat-icon>attach_file</mat-icon>
        </button>
        <input type="file" #fileInput hidden (change)="uploadFile($event)" />

        <input type="text" name="text" [(ngModel)]="itemToSave.text"
          placeholder="Saisissez votre message..."
          class="message-input" (keydown.enter)="saveItem()" />

        <button mat-flat-button type="submit" class="send-button" (click)="saveItem()">
          <mat-icon>send</mat-icon>
          <span class="send-text">Envoyer</span>
        </button>
      </form>

      <div *ngIf="imageName" class="file-selected">
        <i class="fa fa-paperclip mr-1"></i> {{ imageName }}
      </div>

    </div>
  </div>
</div>
